import { ReactNode, useMemo } from 'react';
import LockIcon from '@/creditflowresearch/ui/common/components/molecules/LockIcon/LockIcon';
import { useLockDetection } from './useLockDetection';
import { type IAccessCondition } from '@/creditflowresearch/ui/common/hooks/access/useAccessConditions';

interface IUseTitleWithLockIconOptions {
  title: string | ReactNode,
  activeItems?: Array<{ hasAccess: boolean }>,
  accessConditionsList?: IAccessCondition[],
  hasAccessConditions?: boolean,
}

export const useTitleWithLockIcon = ({
  title,
  activeItems = [],
  accessConditionsList,
  hasAccessConditions = false,
}: IUseTitleWithLockIconOptions): ReactNode => {
  const { shouldShowLock } = useLockDetection({
    activeItems,
    accessConditionsList: accessConditionsList || [],
    hasAccessConditions,
  });

  return useMemo(() => {
    if (!shouldShowLock) {
      return title;
    }

    return <LockIcon>{ title }</LockIcon>;
  }, [title, shouldShowLock]);
};
